// extracted by mini-css-extract-plugin
module.exports = {"mobileLandscapeOverlay":"MobileLandscapeOverlay_mobileLandscapeOverlay__3Q_3c"};